// DO NOT use class field declarations (e.g. quantityInput = undefined).
// Shopify's CDN minifier targets ES5 and cannot transform them.
// All properties must be declared inside the constructor with this.x = ...
// DO NOT revert this file to use class fields or optional chaining (?.)

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();

        this.quantityInput = undefined;
        this.quantityForm = undefined;
        this.onVariantChangeUnsubscriber = undefined;
        this.cartUpdateUnsubscriber = undefined;
        this.abortController = undefined;
        this.pendingRequestUrl = null;
        this.preProcessHtmlCallbacks = [];
        this.postProcessHtmlCallbacks = [];

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push(function(html) {
          html.querySelectorAll('.scroll-trigger').forEach(function(element) {
            element.classList.add('scroll-trigger--cancel');
          });
        });
        this.postProcessHtmlCallbacks.push(function(newNode) {
          if (window && window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
          if (window && window.ProductModel) window.ProductModel.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        if (productForm) productForm.toggleSubmitButton(true);
        if (productForm) productForm.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        var self = this;
        return function(html) {
          if (self.productModal) self.productModal.remove();

          var selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          var variant = self.getSelectedVariant(html.querySelector(selector));
          self.updateURL(productUrl, variant && variant.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              self.preProcessHtmlCallbacks,
              self.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              self,
              html.querySelector('product-info'),
              self.preProcessHtmlCallbacks,
              self.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then(function(response) { return response.text(); })
          .then(function(responseText) {
            var html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(function() {
            var el = document.querySelector('#' + targetId);
            if (el) el.focus();
          })
          .catch(function(error) {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        var el = productInfoNode.querySelector('variant-selects [data-selected-variant]');
        var selectedVariant = el && el.innerHTML;
        return selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage) {
        if (shouldFetchFullPage === undefined) shouldFetchFullPage = false;
        var params = [];

        if (!shouldFetchFullPage) params.push('section_id=' + this.sectionId);

        if (optionValues.length) {
          params.push('option_values=' + optionValues.join(','));
        }

        return url + '?' + params.join('&');
      }

      updateOptionValues(html) {
        var variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        var self = this;
        return function(html) {
          var variant = self.getSelectedVariant(html);

          if (self.pickupAvailability) self.pickupAvailability.update(variant);
          self.updateOptionValues(html);
          self.updateURL(productUrl, variant && variant.id);
          self.updateVariantInputs(variant && variant.id);

          if (!variant) {
            self.setUnavailable();
            return;
          }

          self.updateMedia(html, variant.featured_media && variant.featured_media.id);

          function updateSourceFromDestination(id, shouldHide) {
            if (!shouldHide) shouldHide = function() { return false; };
            var source = html.getElementById(id + '-' + self.sectionId);
            var destination = self.querySelector('#' + id + '-' + self.dataset.section);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          }

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', function(s) { return s.classList.contains('hidden'); });
          updateSourceFromDestination('Inventory', function(s) { return s.innerText === ''; });
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', function(s) { return s.classList.contains('hidden'); });

          self.updateQuantityRules(self.sectionId, html);
          var qrEl = self.querySelector('#Quantity-Rules-' + self.dataset.section);
          if (qrEl) qrEl.classList.remove('hidden');
          var vnEl = self.querySelector('#Volume-Note-' + self.dataset.section);
          if (vnEl) vnEl.classList.remove('hidden');

          var submitBtn = html.getElementById('ProductSubmitButton-' + self.sectionId);
          if (self.productForm) {
            self.productForm.toggleSubmitButton(
              submitBtn ? submitBtn.hasAttribute('disabled') : true,
              window.variantStrings.soldOut
            );
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: self.sectionId,
              html: html,
              variant: variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          '#product-form-' + this.dataset.section + ', #product-form-installment-' + this.dataset.section
        ).forEach(function(productForm) {
          var input = productForm.querySelector('input[name="id"]');
          input.value = variantId || '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        var shareButton = this.querySelector('share-button');
        if (shareButton) shareButton.updateUrl(
          window.shopUrl + url + (variantId ? '?variant=' + variantId : '')
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', url + (variantId ? '?variant=' + variantId : ''));
      }

      setUnavailable() {
        if (this.productForm) this.productForm.toggleSubmitButton(true, window.variantStrings.unavailable);

        var selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map(function(id) { return '#' + id + '-' + this.dataset.section; }.bind(this))
          .join(', ');
        document.querySelectorAll(selectors).forEach(function(el) { el.classList.add('hidden'); });
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        var mediaGallerySource = this.querySelector('media-gallery ul');
        var mediaGalleryDestination = html.querySelector('media-gallery ul');
        var self = this;

        function refreshSourceData() {
          if (self.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          var mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          var sourceSet = new Set(mediaGallerySourceItems.map(function(item) { return item.dataset.mediaId; }));
          var sourceMap = new Map(
            mediaGallerySourceItems.map(function(item, index) { return [item.dataset.mediaId, { item: item, index: index }]; })
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        }

        if (mediaGallerySource && mediaGalleryDestination) {
          var refreshed = refreshSourceData();
          var mediaGallerySourceItems = refreshed[0];
          var sourceSet = refreshed[1];
          var sourceMap = refreshed[2];

          var mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          var destinationSet = new Set(mediaGalleryDestinationItems.map(function(el) { return el.dataset.mediaId; }));
          var shouldRefresh = false;

          for (var i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          for (var i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          if (shouldRefresh) {
            refreshed = refreshSourceData();
            mediaGallerySourceItems = refreshed[0];
            sourceSet = refreshed[1];
            sourceMap = refreshed[2];
          }

          mediaGalleryDestinationItems.forEach(function(destinationItem, destinationIndex) {
            var sourceData = sourceMap.get(destinationItem.dataset.mediaId);
            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector('li:nth-of-type(' + (destinationIndex + 1) + ')')
              );
              refreshed = refreshSourceData();
              mediaGallerySourceItems = refreshed[0];
              sourceSet = refreshed[1];
              sourceMap = refreshed[2];
            }
          });
        }

        var mediaGallery = this.querySelector('media-gallery');
        if (mediaGallery && mediaGallery.setActiveMedia) {
          mediaGallery.setActiveMedia(this.dataset.section + '-' + variantFeaturedMediaId, true);
        }

        var modalContent = this.productModal && this.productModal.querySelector('.product-media-modal__content');
        var newModalContent = html.querySelector('product-modal .product-media-modal__content');
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        var data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        var min = data.min;
        var max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        var self = this;
        var currentVariantId = this.productForm && this.productForm.variantIdInput && this.productForm.variantIdInput.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(this.dataset.url + '?variant=' + currentVariantId + '&section_id=' + this.dataset.section)
          .then(function(response) { return response.text(); })
          .then(function(responseText) {
            var html = new DOMParser().parseFromString(responseText, 'text/html');
            self.updateQuantityRules(self.dataset.section, html);
          })
          .catch(function(e) { console.error(e); })
          .finally(function() {
            self.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        var quantityFormUpdated = html.getElementById('Quantity-Form-' + sectionId);
        var selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (var i = 0; i < selectors.length; i++) {
          var selector = selectors[i];
          var current = this.quantityForm.querySelector(selector);
          var updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            var attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (var j = 0; j < attributes.length; j++) {
              var attribute = attributes[j];
              var valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              var updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                var labelId = updatedAriaLabelledBy;
                var currentHiddenLabel = document.getElementById(labelId);
                var updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector('product-form');
      }

      get productModal() {
        return document.querySelector('#ProductModal-' + this.dataset.section);
      }

      get pickupAvailability() {
        return this.querySelector('pickup-availability');
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        var relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector('product-recommendations[data-section-id^="' + relatedProductsSectionId + '"]');
      }

      get quickOrderList() {
        var quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector('quick-order-list[data-id^="' + quickOrderListSectionId + '"]');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}